import React, { useState } from "react"
import { Box, Slider, Typography } from "@mui/material"

const OverlayImage = ({ image1Url, image2Url, width, height }) => {
  const [opacity, setOpacity] = useState(0.5)

  const handleSliderChange = (event, newValue) => {
    setOpacity(newValue)
  }

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          bgcolor: "background.default",
          lineHeight: 0,
        }}
      >
        <Box
          component="img"
          src={image1Url}
          alt="Camera feed"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "fill",
            display: "block",
          }}
        />
        {image2Url && (
          <Box
            component="img"
            src={image2Url}
            alt="Detection overlay"
            sx={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              opacity: opacity,
              objectFit: "fill",
              display: "block",
            }}
          />
        )}
      </Box>
      {image2Url && (
        <Box sx={{ px: 3, py: 2 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1, fontSize: "0.8rem" }}
          >
            Overlay opacity
          </Typography>
          <Slider
            value={opacity}
            onChange={handleSliderChange}
            aria-labelledby="opacity-slider"
            min={0}
            max={1}
            step={0.01}
            size="small"
          />
        </Box>
      )}
    </Box>
  )
}

export default OverlayImage
